// extracted by mini-css-extract-plugin
export default {"container":"style_container__5IfHs","titleSection":"style_titleSection__Jplu2"};